import DataMapper from './DataMapper'
import CaseServiceDataRM from '../responsemodel/CaseServiceDataRM'
import CaseServiceData from '../../models/CaseServiceData'
class CaseServiseDetailDataMapper extends DataMapper<CaseServiceDataRM, CaseServiceData> {
    map = (rm: CaseServiceDataRM) => new CaseServiceData(rm.AttendentInfoData, rm.DoctorPathologistsData, rm.HospitalInfrastructureData, rm.InsuredInfoData, rm.TreatingDoctorsData)
}
export default CaseServiseDetailDataMapper